<template>
  <div class="app">
    <splitpanes class="default-theme">
      <pane size="20">
        <bd-aside></bd-aside>
      </pane>
      <pane size="80">
        <bd-main></bd-main>
      </pane>
    </splitpanes>
  </div>
</template>

<script>
// https://antoniandre.github.io/splitpanes/
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
// import { Layout } from 'vue-split-layout'
import BdAside from '@/components/dashboard/main/contact/BdAside'
import BdMain from '@/components/dashboard/main/contact/BdMain'

export default {
  name: 'bd-online',
  // components: { BdAside, BdMain, Layout },
  components: { BdAside, BdMain, Splitpanes, Pane },
  data () {
    return {
      // resize: true,
      // splits: {
      //   dir: 'horizontal',
      //   first: 0,
      //   second: 1,
      //   split: '20%'
      // }
    }
  }
}
</script>

<style scope>
</style>
